import { ArrayLayoutProps } from "@jsonforms/core";

export function hasHeading(props: ArrayLayoutProps) {
  return props.uischema.options?.showListHeading === true;
}
